import { fontStyleHeadings2 } from 'components/Common/styles.js'

export const trackStyles = {
  trackSummaryHeadingContainer: {
    padding: '30px 0px 30px 15px'
  },
  trackSummaryHeadingStyle: fontStyleHeadings2
}



// WEBPACK FOOTER //
// ./src/components/Track/styles/TrackPageStyle.js